import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import Billing from './index.js'

if (!store?.state?.Billing) {
	store.registerModule('Billing', Billing)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('Billing')
